'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fSegmentedButton$002ejs from "@ui5/webcomponents/dist/SegmentedButton.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp from "./com.raquo.laminar.keys.-Event-Prop.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.If = null;
  this.Ig = false;
  this.Ih = null;
  this.Ii = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-segmented-button");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$.prototype = $p;
$p.RO = (function() {
  if ((!this.Ig)) {
    this.If = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "accessible-name", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Ig = true;
  }
  return this.If;
});
$p.xO = (function() {
  if ((!this.Ii)) {
    this.Ih = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp.$c_Lcom_raquo_laminar_keys_EventProp("selection-change");
    this.Ii = true;
  }
  return this.Ih;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fSegmentedButton$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$, "io.github.nguyenyou.ui5.webcomponents.laminar.SegmentedButton$", ({
  jH: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButton$ };
